import { apiServer } from 'settings/web-services/api';
import { MULTIPLE_TASKS } from 'app-constants/endpoints';

export const getTaskAggregate = (cfg) => apiServer.get(MULTIPLE_TASKS, { params: cfg?.filters });
